var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.room)?_c('div',{staticClass:"rooms"},[_c('div',{staticClass:"breadcrumbs"},[_c('h2',[_vm._v("Edit "+_vm._s(_vm.room.title))])]),_c('RoomForm',{attrs:{"saving":_vm.saving,"room":_vm.room},on:{"save":_vm.save}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }